module.exports = __webpack_public_path__ + "e18b6d70af229391cff3a29ced065f3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/owl-ffel-tower-empty.png
// module id = 333
// module chunks = 0